import { render } from "./ProjectsRoot.vue?vue&type=template&id=5681386e"
import script from "./ProjectsRoot.vue?vue&type=script&lang=js"
export * from "./ProjectsRoot.vue?vue&type=script&lang=js"

import "./ProjectsRoot.vue?vue&type=style&index=0&id=5681386e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__